/// <amd-module name="Wit/WorkItems/LinkConstants" />

export const enum LinkReferenceNames {
    Parent = "System.LinkTypes.Hierarchy-Reverse",
    Child = "System.LinkTypes.Hierarchy-Forward",
    TestedBy = "Microsoft.VSTS.Common.TestedBy-Forward",
    Test = "Microsoft.VSTS.Common.TestedBy-Reverse"
}

export namespace LinkTypeConstants {
    export const AttachmentReferenceName = "AttachedFile";
    export const HyperlinkReferenceName = "Hyperlink";
    export const ArtifactLinkReferenceName = "ArtifactLink";
}
